import { afterNextRender, ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { VideoPlayerComponent } from '../../media/video-player/video-player.component';
import { PresentationController } from '../../presentation-controller';
import { SlideLayoutConfigService } from '../../slide-layout-config.service';

@Component({
  selector: 'ds-fullscreen-layout',
  imports: [VideoPlayerComponent],
  templateUrl: './fullscreen-layout.component.html',
  styleUrls: ['./fullscreen-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FullscreenLayoutComponent {
  private readonly config = inject(SlideLayoutConfigService);

  public readonly controller = input.required<PresentationController>();
  public readonly slide = computed(() => this.controller().slide);
  public readonly content = computed(() => this.slide().content);
  public readonly image = computed(() => this.controller().image());
  public readonly closedCaptions = this.config.closedCaptions;

  public constructor() {
    afterNextRender(() => this.startCarousel());
  }

  private startCarousel(): void {
    const controller = this.controller();
    const slide = controller.slide;
    const images = slide.images ?? slide.content.images ?? [];

    if (slide.content.showVideo || images.length === 0) {
      return;
    }

    controller.wait(controller.carousel(images, slide.carouselSecondsPerImage ?? this.config.carouselSeconds()));
  }
}
